import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  }
];

export let CoreRoutes: ModuleWithProviders = RouterModule.forChild(routes);


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/core.routes.ts